
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M8 8a2 2 0 00-2 2v2.667a.667.667 0 01-1.333 0V9.976a2.304 2.304 0 01-.551.014A.641.641 0 014 10h-.286c-.578 0-1.047.469-1.047 1.048V12a.667.667 0 01-1.334 0v-.952a2.38 2.38 0 011.11-2.014 2.334 2.334 0 012.9-3.471 2.667 2.667 0 115.314 0 2.334 2.334 0 012.9 3.471 2.38 2.38 0 011.11 2.014V12a.667.667 0 01-1.334 0v-.952c0-.579-.469-1.048-1.047-1.048H12a.634.634 0 01-.116-.01 2.236 2.236 0 01-.551-.014v2.691a.666.666 0 11-1.333 0V10a2 2 0 00-2-2zm0-1.333A1.333 1.333 0 118 4a1.333 1.333 0 010 2.667zm-3.667 0a1 1 0 100 2 1 1 0 000-2zm7.334 0a1 1 0 10-.002 1.998 1 1 0 00.002-1.998z","clip-rule":"evenodd"}})])
          )
        }
      }
    